// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_DWARVES = [{
  id: 'dwarves_mine',
  factionId: FACTIONS.DWARVES,
  name: 'Страж рудника',
  priceNumens: 4000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.BLUE
  ]
}, {
  id: 'dwarves_ram',
  factionId: FACTIONS.DWARVES,
  name: 'Клан Барана',
  priceNumens: 27000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'dwarves_north',
  factionId: FACTIONS.DWARVES,
  name: 'Клан Волка',
  priceNumens: 75000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.INDIGO
  ]
}, {
  id: 'dwarves_gold_legacy',
  factionId: FACTIONS.DWARVES,
  name: 'Рудознатец',
  priceNumens: 70000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'dwarves_ruby_legacy',
  factionId: FACTIONS.DWARVES,
  name: 'Самоцветный тан',
  priceCrystals: 200,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
